import React from 'react'

import { ModalCopyPixKeyContainer } from './styles'

export  function ModalCopyPix() {

    return (
        <>
            <ModalCopyPixKeyContainer>
                <div id="open-modal" class="modal-window2">
                    <div>
                       Código copiado com sucesso
                    </div>
                </div>
            </ModalCopyPixKeyContainer>
        </>
    )
}
